// removed by extract-text-webpack-plugin
module.exports = {"agencyInfoWindow":"_1KqVay1E3LF-GuEJgM3lg9","agencyLogo":"S8gPyFhXsHlIdHQnyMIL_","agencyContent":"_2WsU0_f-Rzr0PYmKMHJ3T1","agencyTitle":"_36B83lF4nIEx8qjuFYPGOQ","agencyInfo":"_1WRp31_oXYGB-hxbWLamKV","pageLink":"_3tndyagCMpQHIshoUUZUu2","defaultLang":"_2dflgH2yu7k2C5e8EInDrk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AgencyInfoWindow/AgencyInfoWindow.scss
// module id = 1551
// module chunks = 0